import { anton } from '@/lib/font';
import styles from './RoundTextIcon.module.scss';

function RoundTextIcon({
  bgColor,
  text,
  textColor = 'white',
  fontWeight = 'normal',
  fontStyle = 'anton',
  size = 'default',
  borderColor = '',
}: {
  bgColor: string;
  text: string;
  textColor?: string;
  fontWeight?: 'normal' | 'bold';
  fontStyle?: 'normal' | 'anton';
  size?: 'xSmall' | 'small' | 'default' | 'defaultFixed' | 'large' | 'xLarge';
  borderColor?: string;
}) {
  const generateContainerStyle = () => {
    const style = { backgroundColor: `var(--color-${bgColor})` };
    return borderColor ? { ...style, ...{ border: `1px solid var(--color-${borderColor})` } } : style;
  };

  return (
    <div
      className={`${styles.componentStyle} ${styles[`${size}Container`]} ${styles.commonContainer}`}
      style={generateContainerStyle()}
    >
      <span
        className={`${styles[`${size}Text`]} ${fontStyle === 'normal' ? '' : anton.className}`}
        style={{
          color: `var(--color-${textColor})`,
          fontWeight: fontWeight,
          fontStyle: fontStyle,
        }}
      >
        {text}
      </span>
    </div>
  );
}

export default RoundTextIcon;
